export const PAGE_LOADING = 'PAGE_LOADING';